import React, { useState, useRef, useEffect } from "react";

import Nav from "react-bootstrap/Nav";
import axios from "axios";
import Table from "react-bootstrap/Table";
import loading1 from "../../assets/img/loading-gif.gif";
import loadingwithdraww from "../../assets/img/loading-gif.gif";
import Swal from "sweetalert2";
import Tab from "react-bootstrap/Tab";
import { MdCurrencyRupee } from "react-icons/md";
import $ from "jquery";
import { fetchwalletamount } from "../../common.js";
import { Spinner } from "react-bootstrap";
import { Container } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { Button, Form, Input, message, Space, Modal, Tooltip } from "antd";
import Withdrawhistory from "./Withdrawhistory.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { use } from "react";
import { useLocation } from "react-router-dom";

export default function Wallet() {
    const navigate = useNavigate();
    const location = useLocation();
    const amount = localStorage.getItem('amount')
    // const amount = location.state?.amount || 0;
    const [amountvalue, setvalue] = useState("");
    const [users, setUsers] = useState([]);
 const isAdmined = localStorage.getItem("isAdmin");
    const userTokened = localStorage.getItem("userToken");
    useEffect(() => {
    
      if (!userTokened  || !isAdmined === "false") {
        navigate("/");
        localStorage.clear();
      }
    }, [!isAdmined]);
    const [winamount, setwinamount] = useState([]);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [loadingwithdraw, setLoadingwithdraw] = useState(false);
    const isButtonLoading = useRef(false);
    const [loadingbutton, setLoadingbutton] = useState(false);
    const [loading, setLoading] = useState(false);
    const [valueswithdraw, setValueswithdraw] = useState([]);
    const [activeQRCodes, setactiveQRCode] = useState([]);
    const [banklistLength, setBanklistLength] = useState(0);
    const [activeQRCodeLength, setactiveQRCodeLength] = useState(0);
    const [slipImage, setSlipImage] = useState(null);
    const [username, setUsername] = useState("");
    const [userName, setUserName] = useState("");
    const [selectedBanks, setSelectedBanks] = useState({
        bankId: "",
        scannerId: activeQRCodes._id,
        bankName: "",
        ifscCode: "",
        accountNumber: "",
        accountHolderName: "",
    });

    const [filteredValues1, setFilteredValues1] = useState([]);
    const [bankNames, setBankNames] = useState("");
    const userid = localStorage.getItem("userid");
    const changevalue = (e) => {
        setvalue(e.target.value);
    };
    const [loading123, setLoading123] = useState(true); // Loading state
    useEffect(() => {
        const getQRActive = async () => {
            try {
                setLoading123(true); // Start loading before fetching data
                const url = `https://api.Cash365days.in/user/get-QRActive-CodeList`;
                const response = await fetch(url);
                const data = await response.json();

                const activeQRCode = data.activeQRCode || [];
                console.log(activeQRCode);
                setactiveQRCode(activeQRCode);
                setactiveQRCodeLength(activeQRCode.length);

            } catch (error) {
                console.error("Error fetching QR codes:", error);
            } finally {
                setLoading123(false); // Stop loading after data fetch
            }
        };

        getQRActive();
    }, []);

    const onFinish = () => {
        // message.success('Submit success!');
    };

    const onFinishFailed = () => {
        message.error("Submit failed!");
    };

    useEffect(() => {
        loaduser1();
    }, []);

    const [utrError, setUtrError] = useState(null);
    const [usernameError, setUsernameError] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                const response = await fetch(`https://api.Cash365days.in/user/user-profile`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ userId: userid }),
                });

                const data = await response.json();
                if (data.success === 1) {

                    setUserName(data.user.userName); // Set balance in state
                } else {
                    console.error("Error:", data.message);
                }
            } catch (err) {
                setError("Failed to fetch user profile");
            } finally {
                setLoading(false);
            }
        };

        fetchUserProfile();
    }, [userid]);


    const loaduser1 = async () => {
        const userid = localStorage.getItem("userid");
        const dev_id = localStorage.getItem("dev_id");
        setLoadingwithdraw(true);
        let url = `https://api.Cash365days.in/user/transaction-history`;


        var config = {
            method: "get",
            url: url
        };
        axios
            .get(url, config)
            .then(function (response) {
                const res = JSON.stringify(response.data);
                setUsers(response.data.transactions);
                const msg = response.data.message;
                var winamount = response.data.winAmount;
                setwinamount(winamount);
                if (res != undefined) {
                    const objectRes = JSON.parse(res);

                }
            })
            .finally(() => {
                setLoadingwithdraw(false);
            });
    };

    const user_id = localStorage.getItem("userid");
    const dev_id = localStorage.getItem("dev_id");
    const [inputValuedeposit, setInputValuedeposit] = useState("");

    const handleAdd = () => {
        navigate("/Transaction");
    }

    const handleDeposit = async () => {
        if (!activeQRCodes || activeQRCodes.status !== "active") {
            if (banklistLength <= 0) {
                Swal.fire({
                    icon: "error",
                    title: "Bank Selection Required",
                    text: "No valid bank found. Please select a valid bank before proceeding!",
                });
                return;
            }
            if (!selectedBanks?.bankName) {
                Swal.fire({
                    icon: "error",
                    title: "Bank",
                    text: "Please select a valid bank!",
                });
                return;
            }
        }

        if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
            Swal.fire({
                icon: "error",
                title: "Amount",
                text: "Please enter a valid deposit amount!",
            });
            return;
        }
        if (!slipImage) {
            Swal.fire({
                icon: "error",
                title: "Payment Slip",
                text: "Please upload a valid payment slip image!",
            });
            return;
        }
        if (!UtrNumber || !/^[a-zA-Z0-9]{10,18}$/.test(UtrNumber)) {  // Allowing 10-18 alphanumeric characters
            setUtrError(true);
            Swal.fire({
                icon: "error",
                title: "UTR Number",
                text: "Please enter a valid UTR Number!",
            });
            return;
        } else {
            setUtrError(false);
        }
        const usernameRegex = /^[a-zA-Z0-9_]{5,20}$/;
        if (!userName || !usernameRegex.test(userName)) {
            setUsernameError(true);
            Swal.fire({
                icon: "error",
                title: "User Name",
                text: "Username must be 5-20 characters and can only contain letters, numbers, and underscores.",
            });
            return;
        } else {
            setUsernameError(false);
        }

        // Create FormData to send text and binary (image) data
        const formData = new FormData();
        formData.append("userId", user_id);
        formData.append("amount", parseFloat(amount));
        formData.append("bankId", selectedBanks._id);
        formData.append("bankName", selectedBanks.bankName);
        formData.append("ifscCode", selectedBanks.ifscCode);
        formData.append("accountNumber", selectedBanks.accountNumber);
        formData.append("accountHolderName", selectedBanks.accountHolderName);
        formData.append("userName", userName);
        formData.append("utrNumber", UtrNumber);
        // formData.append("scannerId", null);

        // Append the image file in binary form if available
        if (slipImage) {
            formData.append("slipImage", slipImage);
        }

        try {
            setLoading(true);

            const response = await fetch(`https://api.Cash365days.in/user/deposit`, {
                method: "POST",
                body: formData,  // Sending FormData (automatically sets correct Content-Type)
            });

            const data = await response.json();

            if (data.success === 1) {
                setLoading(false);
                setIsButtonDisabled(true);
                Swal.fire({
                    title: data.message,
                    icon: "success",
                    timer: 2000,
                }).then(() => {
                    loaduser1();
                    navigate("/DepositPage");
                });
                localStorage.removeItem("amount")
            } else {
                Swal.fire({
                    title: data.message,
                    timer: 3000,
                    icon: "error",
                });
            }
        } catch (error) {
            console.error("Error during deposit:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "An error occurred. Please try again.",
            });
        } finally {
            setLoading(false);
        }
    };


    // Withdrawal Api
    const [bankName, setBankName] = useState("");
    const [accountHolderName, setAccountHolderName] = useState("");

    const [accountNumber, setAccountNumber] = useState("");
    const [otp, setotp] = useState("");
    const [ifscCode, setIfscCode] = useState("");
    const [UtrNumber, setUtrNumber] = useState("");
    const [inputError, setInputError] = useState(false);
    const [bankNameError, setBankNameError] = useState(false);
    const [accountHolderNameError, setAccountHolderNameError] = useState(false);
    const [accountNumberError, setAccountNumberError] = useState(false);
    const [ifscCodeError, setIfscCodeError] = useState(false);

    const [filteredValues, setFilteredValues] = useState([]);
    const [showList, setShowList] = useState(true);


    const [bankList, setBankList] = useState([]);

    const [selectedBank, setSelectedBank] = useState(null);

    const inputRef = useRef(null);

    const fetchBankData = async () => {
        const user_id = localStorage.getItem("userid");
        setLoadingwithdraw(true);

        let url = `https://api.Cash365days.in/user/get-bank-details/${user_id}`;

        axios.get(url) // Change axios.post to axios.get
            .then(function (response) {
                const bankDetails = response.data.normalbankDetails;
                console.warn("dfd", bankDetails);

                if (bankDetails) {
                    setBankName(bankDetails.bankName);
                    setAccountHolderName(bankDetails.accountHolderName);
                    setAccountNumber(bankDetails.accountNumber);
                    setIfscCode(bankDetails.ifscCode);
                    // setStatus(bankDetails.status);  // Store status (pending/approved/success)
                }
            })
            .catch(error => {
                console.error("Error fetching bank details:", error);
            })
            .finally(() => {
                setLoadingwithdraw(false);
            });
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        message.success("Copied to clipboard!");
    };



    useEffect(() => {
        fetchBankData();
        const handleClickOutside = (event) => {
            if (inputRef.current && !inputRef.current.contains(event.target)) {
                setShowList(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);



    useEffect(() => {
        if (valueswithdraw) {
            setFilteredValues(
                valueswithdraw.filter(
                    (item) =>
                        item.bank_name &&
                        bankName &&
                        item.bank_name.toLowerCase().includes(bankName.toLowerCase())
                )
            );
        }
    }, [bankName, valueswithdraw]);

    // bankName list api

    useEffect(() => {
        const getBankList = async () => {
            try {
                const url = `https://api.Cash365days.in/admin/get-bank-list`;
                const response = await fetch(url);
                const data = await response.json();

                const adminBanks = data.banks?.filter(bank => bank.type === "admin" && bank.status === "1") || [];

                setFilteredValues1(adminBanks);
                setBanklistLength(adminBanks.length)
            } catch (error) {
                console.error("Error fetching bank details:", error);
            }
        };

        getBankList();
    }, []);

    const handleBankSelect = (e) => {
        const bankId = e.target.value;
        const bank = filteredValues1.find((b) => b._id === bankId);
        setSelectedBank(bank);
        setSelectedBanks(bank || {
            accountNumber: "",
            accountHolderName: "",
            ifscCode: "",
            bankName: "",
        });
    };
    return (
        <>
            {loading123 ? (
                <div className="spinner-wrapper">
                    <div className="loadernew2"></div>
                </div>// Show loading message
            ) : (<section className="transctionformdesign">
                <div className="overlayimagebg"></div>

                <Container className="p-0 margin-bottom-70">
                    <div className="form_tranaction">
                        <Tab.Container
                            id="left-tabs-example"
                            defaultActiveKey="first"
                            className="w-100"
                        >
                            <div className="card rounded">

                                <Tab.Content>
                                    <div className="tab_content_one position-relative">
                                        <h5 className="amoounttotal">Amount :<strong> <MdCurrencyRupee /> {amount}</strong></h5>

                                        {/* <center> */}

                                        <div className="transactiondesign_form">
                                            <div className="selection w-100">
                                                <select onChange={handleBankSelect} className="form-select">
                                                    <option value="">Select a bank</option>
                                                    {filteredValues1.map((bank) => (
                                                        <option key={bank._id} value={bank._id}>
                                                            {bank.bankName}
                                                        </option>
                                                    ))}
                                                </select>

                                            </div>
                                        </div>


                                    </div>
                                    <div className="tab_content_one position-relative">


                                        <div className="bankdetails_design_new">
                                            <p className="">
                                                Bank Account Details
                                            </p>
                                        </div>

                                        <div className="transactiondesign_form">

                                            <Form name="basic"
                                                labelCol={{
                                                    span: 24,
                                                }}
                                                wrapperCol={{
                                                    span: 24,
                                                }}
                                                layout="horizontal"
                                                onFinish={onFinish}
                                                onFinishFailed={onFinishFailed}
                                                autoComplete="off"
                                                className="position-relative"
                                            >
                                                <React.Fragment>
                                                    <Form.Item className="mb-2 labelform" label="Bank Name">
                                                        <div className="position-relative w-100">
                                                            <Input
                                                                placeholder="Bank Name"
                                                                disabled
                                                                value={selectedBanks.bankName}
                                                                className="form-control forminputdesign pe-5"
                                                            />
                                                            <Tooltip title="Copy Bank Name">
                                                                <i
                                                                    className="bi bi-clipboard position-absolute"
                                                                    style={{ top: "50%", right: "10px", transform: "translateY(-50%)", cursor: "pointer" }}
                                                                    onClick={() => handleCopy(selectedBanks.bankName)}
                                                                ></i>
                                                            </Tooltip>
                                                        </div>
                                                    </Form.Item>

                                                    <Form.Item className="mb-2 labelform" label="Account Holder Name">
                                                        <div className="position-relative w-100">
                                                            <Input
                                                                placeholder="Account Holder Name"
                                                                disabled
                                                                value={selectedBanks.accountHolderName}
                                                                className="form-control forminputdesign pe-5"
                                                            />
                                                            <Tooltip title="Copy Account Holder Name">
                                                                <i
                                                                    className="bi bi-clipboard position-absolute"
                                                                    style={{ top: "50%", right: "10px", transform: "translateY(-50%)", cursor: "pointer" }}
                                                                    onClick={() => handleCopy(selectedBanks.accountHolderName)}
                                                                ></i>
                                                            </Tooltip>
                                                        </div>
                                                    </Form.Item>

                                                    <Form.Item className="mb-2 labelform" label="Account Number">
                                                        <div className="position-relative w-100">
                                                            <Input
                                                                placeholder="Account Number"
                                                                disabled
                                                                value={selectedBanks.accountNumber}
                                                                className="form-control forminputdesign pe-5"
                                                            />
                                                            <Tooltip title="Copy Account Number">
                                                                <i
                                                                    className="bi bi-clipboard position-absolute"
                                                                    style={{ top: "50%", right: "10px", transform: "translateY(-50%)", cursor: "pointer" }}
                                                                    onClick={() => handleCopy(selectedBanks.accountNumber)}
                                                                ></i>
                                                            </Tooltip>
                                                        </div>
                                                    </Form.Item>

                                                    <Form.Item className="mb-2 labelform" label="IFSC Code">
                                                        <div className="position-relative w-100">
                                                            <Input
                                                                placeholder="IFSC Code"
                                                                disabled
                                                                value={selectedBanks.ifscCode}
                                                                className="form-control forminputdesign pe-5"
                                                            />
                                                            <Tooltip title="Copy IFSC Code">
                                                                <i
                                                                    className="bi bi-clipboard position-absolute"
                                                                    style={{ top: "50%", right: "10px", transform: "translateY(-50%)", cursor: "pointer" }}
                                                                    onClick={() => handleCopy(selectedBanks.ifscCode)}
                                                                ></i>
                                                            </Tooltip>
                                                        </div>
                                                    </Form.Item>
                                                </React.Fragment>

                                                <Form.Item
                                                    className="mb-2 labelform"
                                                    label="User Name"
                                                    rules={[{ required: true, message: "Username is required!" }]}
                                                >
                                                    <Input
                                                        placeholder="Enter User Name"
                                                        value={userName}
                                                        // onChange={(e) => setUserName(e.target.value)}
                                                        readOnly
                                                        className={`form-control forminputdesign ${usernameError ? "is-invalid" : ""}`}
                                                    />
                                                    {usernameError && (
                                                        <div className="invalid-feedback">
                                                            Username must be 5–20 characters and only contain letters, numbers, and underscores.
                                                        </div>
                                                    )}
                                                </Form.Item>
                                                <Form.Item
                                                    className="mb-2 labelform"
                                                    label="UTR Number"
                                                    rules={[
                                                        { required: true, message: "UTR Number is required" },
                                                        { type: "string" },
                                                    ]}
                                                >
                                                    <Input
                                                        type="text"
                                                        placeholder="Enter UTR Number"
                                                        value={UtrNumber}
                                                        onChange={(e) => {
                                                            const input = e.target.value.replace(/[^a-zA-Z0-9]/g, ""); // Remove special characters
                                                            const limitedInput = input.slice(0, 12); // Limit to 16 characters
                                                            const upperCaseInput = limitedInput.toUpperCase(); // Convert to uppercase
                                                            setUtrNumber(upperCaseInput);
                                                        }}
                                                        className={`form-control forminputdesign ${utrError ? "is-invalid" : ""}`}
                                                    />
                                                    {utrError && <div className="invalid-feedback">UTR Number required</div>}
                                                </Form.Item>
                                                <Form.Item
                                                    className="mb-2 labelform"
                                                    label="Upload Payment Slip"
                                                    rules={[{ required: activeQRCodes.status !== "active", message: "Slip image is required" }]}
                                                >
                                                    <Input
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            if (file) {
                                                                setSlipImage(file);
                                                            }
                                                        }}
                                                        className="form-control forminputdesign"
                                                    />
                                                </Form.Item>
                                                <button
                                                    className=" btnaddpoints"
                                                    disabled={loading}
                                                    onClick={handleDeposit}
                                                >
                                                    Deposit
                                                    {loading && <Spinner animation="border" />}
                                                </button>
                                            </Form>
                                        </div>
                                    </div>
                                </Tab.Content>


                            </div>
                        </Tab.Container>

                    </div>
                </Container>

                <ToastContainer />
            </section>
            )}
            {loading2 && (
                <div className="spinner-wrapper">
                    <div className="loadernew2"></div>
                </div>
            )}
            {loading3 && (
                <div className="spinner-wrapper">
                    <div className="loadernew2"></div>
                </div>
            )}
        </>
    );
}
